
import React from "react";
import { useTheme } from "@material-ui/core";
import HvIconBase from "./IconBase";

const sizeSelector = (iconSize, height, width) => {
  if (height && width) {
    return { width, height };
  }

  switch (iconSize) {
    case "XS":
      return { width: 12, height: 12 };
    default:
    case "S":
      return { width: 16, height: 16 };
    case "M":
      return { width: 32, height: 32 };
    case "L":
      return { width: 96, height: 96 };
  }
};

const Car = ({
  color,
  iconSize = "S",
  viewbox = "0 0 16 16",
  height,
  width,
  semantic,
  inverted = false,
  svgProps,
  ...others
}) => {
  const theme = useTheme();
  const getColor = c => theme.palette?.[c] || c;
  const colorArray = 
    (typeof color === "string" && [getColor(color)]) ||
    (Array.isArray(color) && color.map?.(getColor)) ||
    ["none",theme.palette.acce1];

  if (semantic) {
    colorArray[0] = theme.palette?.[semantic] || colorArray[0];
  }

  if (inverted && colorArray[1]) {
    colorArray[1] = colorArray[0];
    colorArray[0] = "none";
  }

  const size = sizeSelector(iconSize, height, width);

  return (
    <HvIconBase name="Car" iconSize={iconSize ?? "S"} {...others}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewbox} height={size.height} width={size.width}   focusable={false} {...svgProps}>
  <path fill={colorArray[0]} className="color0"  stroke="#414141" strokeMiterlimit={10} strokeWidth={3} d="M-7.5-6.5h29v29h-29z" />
  <path fill={colorArray[1]} className="color1"  d="M13.47351 7l-1.81988-5h-7.3039L4 2.96094 2.52985 7H0v6h2.07074a1.99068 1.99068 0 003.85852 0h4.14148a1.99068 1.99068 0 003.85852 0H16V7zM5.04993 3h5.9035l1.45587 4H3.59406zM4 13.5a1 1 0 111-1 1 1 0 01-1 1zm8 0a1 1 0 111-1 1 1 0 01-1 1zm3-1.5h-1.07074a1.99068 1.99068 0 00-3.85852 0H5.92926a1.99068 1.99068 0 00-3.85852 0H1V8h14z" />
</svg>
    </HvIconBase>
)};

Car.propTypes = HvIconBase.propTypes;

export default Car;